/* NINEPADEL article body clean-up. Articles were imported from WordPress (Elementor + Rey/WooCommerce),
   so the body can hold layout wrappers, lazy-loaded images, product grids and loose text without <p>.
   This normalises it into plain prose the theme styles, without changing the stored data. */
(function(){
  var WRAP = document.querySelector('[data-wp]'); if(!WRAP) return;
  var KEEP = /^(np-|prod|verdict|tblwrap|wp-block-|gallery)/;
  var INLINE = /^(A|ABBR|B|BDI|BR|CODE|DEL|EM|I|INS|MARK|S|SMALL|SPAN|STRONG|SUB|SUP|U|TIME|IMG)$/;
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
  var money = function(c){ return window.NP && NP.formatMoney ? NP.formatMoney(c) : '£' + (c/100).toFixed(2); };
  var $$ = function(sel, el){ return [].slice.call((el || WRAP).querySelectorAll(sel)); };

  /* Old-site links: products and posts to their Shopify equivalents. */
  function mapUrl(href){
    var m = /^https?:\/\/(?:www\.)?ninepadel\.com(\/[^?#]*)?(.*)$/i.exec(href || ''); if(!m) return href;
    var path = m[1] || '/', p;
    if((p = /^\/product\/([^\/]+)\/?$/.exec(path))) return '/products/' + p[1];
    if((p = /^\/(?:padel-racket-guides|padel-racket-reviews|padel-news[^\/]*|blog|news)\/([^\/]+)\/?$/.exec(path))) return '/blogs/news/' + p[1];
    return href;
  }

  /* 1. Junk from the old theme */
  $$('.elementor-widget-post-navigation, .elementor-post-navigation, [class*="bPostGrid"], .screen-reader-text, .elementor-screen-only, .gtm4wp_productdata, .__break, script, style, noscript, .rey-productThumbnail__second, .wcosm_soldout').forEach(function(n){ n.remove(); });
  $$('h1').forEach(function(n){ n.remove(); });
  $$('h2, h3, h4, p').forEach(function(n){ if(/^(read more|related posts?|you may also like|previous|next)$/i.test(n.textContent.trim())) n.remove(); });

  /* 2. Lazy images */
  $$('img').forEach(function(img){
    var ds = img.getAttribute('data-src'), dss = img.getAttribute('data-srcset');
    if(ds){ img.src = ds; img.removeAttribute('data-src'); }
    if(dss){ img.setAttribute('srcset', dss); img.removeAttribute('data-srcset'); }
    if(/^data:image\/gif/.test(img.getAttribute('src') || '')) img.remove();
    else { img.loading = 'lazy'; img.classList.remove('lazyload'); }
  });

  /* 3. WooCommerce product grids -> product cards */
  function card(li){
    var a = li.querySelector('.woocommerce-loop-product__title a, a.woocommerce-LoopProduct-link, a[href*="/product/"]');
    var title = (li.querySelector('.woocommerce-loop-product__title') || a || {}).textContent || '';
    var img = li.querySelector('.rey-thumbImg, img');
    var price = li.querySelector('.price ins .amount, .price > .amount, .price .amount');
    var was = li.querySelector('.price del .amount');
    var badge = li.querySelector('.rey-itemBadge, .rey-discount');
    if(was && price && was.textContent.trim() === price.textContent.trim()){ was = null; if(badge && badge.classList.contains('rey-discount')) badge = null; }
    var soon = li.classList.contains('outofstock');
    var href = a ? mapUrl(a.getAttribute('href')) : '#';
    var el = document.createElement('a'); el.className = 'prod'; el.href = href;
    el.innerHTML = '<div class="im">' + (img ? '<img src="' + esc(img.getAttribute('src')) + '" alt="" loading="lazy">' : '') + (badge && badge.textContent.trim() ? '<span class="tg">' + esc(badge.textContent.trim()) + '</span>' : '') + '</div>' +
      '<div class="t"><b>' + esc(title.trim()) + '</b><span class="pr">' + (price ? '<span' + (was ? ' class="red"' : '') + '>' + esc(price.textContent.trim()) + '</span>' : '') + (was ? '<s>' + esc(was.textContent.trim()) + '</s>' : '') + '</span></div>' +
      '<span class="go' + (soon ? ' soon' : '') + '">' + (soon ? 'Coming soon' : 'View racket') + '</span>';
    /* Refresh from Shopify: live price, stock, image and a working link. */
    var h = /^\/products\/([^\/?#]+)/.exec(href);
    if(h) fetch('/products/' + h[1] + '.js', {headers:{Accept:'application/json'}}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(p){
      el.href = p.url || href;
      el.querySelector('.t b').textContent = p.title;
      var pr = el.querySelector('.pr'), off = p.compare_at_price > p.price;
      pr.innerHTML = '<span' + (off ? ' class="red"' : '') + '>' + money(p.price) + '</span>' + (off ? '<s>' + money(p.compare_at_price) + '</s>' : '');
      if(p.featured_image){ var src = p.featured_image.replace(/(\.\w+)(\?|$)/, '_400x$1$2'); var im = el.querySelector('.im img'); if(im) im.src = src; else el.querySelector('.im').insertAdjacentHTML('afterbegin', '<img src="' + src + '" alt="" loading="lazy">'); }
      var go = el.querySelector('.go'), tg = el.querySelector('.tg');
      if(p.available){ go.className = 'go'; go.textContent = 'View racket'; if(tg && /soon|sold|out/i.test(tg.textContent)) tg.remove(); }
      else { go.className = 'go soon'; go.textContent = 'Sold out'; }
    }).catch(function(){ el.href = '/search?type=product&q=' + encodeURIComponent(title.trim()); });
    return el;
  }
  $$('ul.products, .splide').forEach(function(list){
    if(!WRAP.contains(list)) return;
    var items = [].slice.call(list.querySelectorAll('li.product')); if(!items.length) return;
    var box = document.createElement('div'); box.className = 'prods';
    items.forEach(function(li){ box.appendChild(card(li)); });
    var host = list.closest('.reyEl-productGrid, .elementor-widget-container, .splide') || list;
    if(host === WRAP || !WRAP.contains(host)) host = list;
    host.parentNode.replaceChild(box, host);
  });

  /* 4. Links + inline styles */
  $$('a[href]').forEach(function(a){ a.setAttribute('href', mapUrl(a.getAttribute('href'))); });
  $$('[style]').forEach(function(n){ n.removeAttribute('style'); });
  $$('[data-start],[data-end]').forEach(function(n){ n.removeAttribute('data-start'); n.removeAttribute('data-end'); });

  /* 5. Unwrap layout-only wrappers (Elementor containers, styled divs) */
  function unwrap(n){ var p = n.parentNode; while(n.firstChild) p.insertBefore(n.firstChild, n); p.removeChild(n); }
  var guard = 0, found;
  do { found = false;
    $$('div, section, article').forEach(function(d){
      if(!d.parentNode || d.closest('.prods, .prod')) return;
      for(var a = d.parentNode; a && a !== WRAP; a = a.parentNode){ if(a.className && typeof a.className === 'string' && a.className.split(/\s+/).some(function(c){ return KEEP.test(c); })) return; }
      var cls = d.className && typeof d.className === 'string' ? d.className.trim().split(/\s+/) : [];
      if(cls.some(function(c){ return KEEP.test(c); })) return;
      unwrap(d); found = true;
    });
  } while(found && ++guard < 20);

  /* 6. Loose text runs -> paragraphs (WordPress would have added <p>) */
  function paragraphs(host){
    var kids = [].slice.call(host.childNodes), run = [];
    function flush(){
      if(!run.length) return;
      var html = run.map(function(n){ return n.nodeType === 3 ? esc(n.textContent) : n.outerHTML; }).join('');
      var parts = html.split(/\n\s*\n|\n|(?:<br\s*\/?>\s*){2,}/);
      var first = run[0];
      parts.forEach(function(t){ if(!t.replace(/&nbsp;|\s|<br\s*\/?>/g, '')) return; var p = document.createElement('p'); p.innerHTML = t.trim(); host.insertBefore(p, first); });
      run.forEach(function(n){ n.parentNode && n.parentNode.removeChild(n); }); run = [];
    }
    kids.forEach(function(n){
      if(n.nodeType === 3 || (n.nodeType === 1 && INLINE.test(n.tagName))) run.push(n);
      else if(n.nodeType === 8) n.remove();
      else flush();
    });
    flush();
  }
  paragraphs(WRAP);
  $$('.np-card > div, .np-cta, .np-col, .np-guide').forEach(paragraphs);
  $$('.np-guide').forEach(function(g){ paragraphs(g); unwrap(g); });
  $$('p').forEach(function(p){ if(!p.textContent.replace(/ |\s/g, '') && !p.querySelector('img,iframe')) p.remove(); });

  /* 7. "Best for / Skip if" pairs -> verdict boxes */
  $$('p').forEach(function(p){
    var s = p.firstElementChild;
    if(!s || !/^(STRONG|B)$/.test(s.tagName) || !/^best for/i.test(s.textContent.trim())) return;
    var nx = p.nextElementSibling, s2 = nx && nx.firstElementChild;
    var box = document.createElement('div'); box.className = 'verdict';
    s.remove(); var yes = '<div class="yes"><span><svg class="i sm" aria-hidden="true"><use href="#i-check"/></svg>Best for</span>' + p.innerHTML.replace(/^(\s|<br\s*\/?>|:|-|&nbsp;)*/, '') + '</div>';
    var no = '';
    if(nx && nx.tagName === 'P' && s2 && /^(STRONG|B)$/.test(s2.tagName) && /^skip if/i.test(s2.textContent.trim())){ s2.remove(); no = '<div class="no"><span><svg class="i sm" aria-hidden="true"><use href="#i-x"/></svg>Skip if</span>' + nx.innerHTML.replace(/^(\s|<br\s*\/?>|:|-|&nbsp;)*/, '') + '</div>'; nx.remove(); }
    box.innerHTML = yes + no; if(!no) box.classList.add('one');
    p.parentNode.replaceChild(box, p);
  });

  /* 7b. In the old two-column layout a product sat beside the text that follows it: move it to the end of that section */
  $$('.prods').forEach(function(box){
    var nx = box.nextElementSibling; if(!nx || !/^H[23]$/.test(nx.tagName) || box.parentNode !== WRAP) return;
    var end = nx.nextElementSibling;
    while(end && !/^H2$/.test(end.tagName) && !end.classList.contains('prods')) end = end.nextElementSibling;
    WRAP.insertBefore(box, end || null);
  });

  /* 8. Tables scroll on phones */
  $$('table').forEach(function(t){ if(t.parentNode.classList.contains('tblwrap')) return; var d = document.createElement('div'); d.className = 'tblwrap'; t.parentNode.insertBefore(d, t); d.appendChild(t); });
  /* Leading heading that repeats the article title adds nothing under the H1 */
  var h1 = document.querySelector('.npa .ahead h1'), fh = WRAP.firstElementChild;
  if(h1 && fh && /^H2$/.test(fh.tagName) && fh.textContent.trim().toLowerCase() === h1.textContent.trim().toLowerCase()) fh.remove();
  WRAP.classList.add('ready');
  document.dispatchEvent(new CustomEvent('np:article:ready'));
})();

/* Contents, reading progress, copy link */
(function(){
  var root = document.querySelector('[data-npa]'); if(!root) return;
  var bar = document.querySelector('[data-rprog]'), art = root.querySelector('[data-prose]');
  var toc = root.querySelector('[data-toc]'), wrap = root.querySelector('[data-tocwrap]'), used = {};
  function slug(t){ var s = t.toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') || 'section'; var b = s, n = 2; while(used[s] || document.getElementById(s)){ s = b + '-' + n++; } used[s] = 1; return s; }
  var hs = [].slice.call(art.querySelectorAll('.wp h2')).filter(function(h){ return !h.closest('.prod, .np-cta'); });
  hs.forEach(function(h){ if(!h.id) h.id = slug(h.textContent); });
  var links = [];
  if(hs.length > 1){
    toc.innerHTML = hs.map(function(h){ return '<li><a href="#' + h.id + '">' + h.textContent.replace(/[<>&]/g, '') + '</a></li>'; }).join('');
    wrap.hidden = false; links = [].slice.call(toc.querySelectorAll('a'));
  }
  function onScroll(){
    var r = art.getBoundingClientRect(), h = r.height - innerHeight;
    bar.style.width = (h > 0 ? Math.max(0, Math.min(1, -r.top / h)) : 1) * 100 + '%';
    if(links.length){ var cur = 0; hs.forEach(function(s, i){ if(s.getBoundingClientRect().top < 140) cur = i; }); links.forEach(function(a, i){ a.classList.toggle('on', i === cur); }); }
  }
  addEventListener('scroll', onScroll, {passive: true}); onScroll();
  var c = root.querySelector('[data-copy]');
  if(c) c.addEventListener('click', function(){
    var done = function(){ c.classList.add('ok'); c.setAttribute('aria-label', 'Link copied'); setTimeout(function(){ c.classList.remove('ok'); c.setAttribute('aria-label', 'Copy link'); }, 1800); };
    try { navigator.clipboard.writeText(location.href).then(done, function(){}); } catch(e){}
  });
})();
